// import { getActiveUser } from '@/helpers/authHelper'
import { httpPost, httpGet, httpPut, httpDelete, getResponse } from '../helpers/httpClientHelper'
import { configs } from '../common/config'
import * as _gFunc from '@/helpers/funcHelper'
import { useAccessControlStore } from '../store/modules/accessControlStore';
import _ from 'lodash'

export async function login(params) {
	const resp = await httpPost(configs.services.access_control + configs.endPoint.access_control.login, params);
	return getResponse(resp);
}
export async function checkUserInfo() {
	const resp = await httpGet(configs.services.access_control + configs.endPoint.access_control.user_info, {}, true);
	return getResponse(resp);
}
export async function checkAppCode(sub_host_name) {
	const resp = await httpGet(configs.services.apiGateway + '/pub/getCorporateConfig', {subdomain:sub_host_name}, false, false);
	return getResponse(resp);
}
export async function getUserByAppCode() {
	const search = {
		"status": 1,
		"application_code":configs.appCode,
	}
	const resp = await httpGet(configs.services.access_control + '/user_by_app_code', search, true);
	return getResponse(resp);
}
export async function getRoleList() {
	const resp = await httpGet(configs.services.access_control + '/role', {}, true)
	return getResponse(resp);
}
export async function getUserList(search = {}) {
	const accessControl = useAccessControlStore();
	if(_gFunc.isEmpty(accessControl.activeUser))
	{
		accessControl.setActiveUser(JSON.parse(localStorage.getItem('active_user')))
	}
	let searchParams = {
		corporate_id: accessControl.activeUser.account_info.corporate_id
	}
	if(!_gFunc.isEmpty(search))
	{
		searchParams.name = search.name	
	}
	const resp = await httpGet(configs.services.access_control + '/user', searchParams , true)
	accessControl.userList = resp.data.data
	return getResponse(resp);
}
export async function checkEmailUser(email) {
	const accessControl = useAccessControlStore();
	const resp = await httpGet(configs.services.access_control + '/user?email=' + email, {}, true )
	const d = resp.data.data
	let alreadyExist = false
	if (d.length > 0) {
		const groupedData = _.groupBy(d, 'id');
		const result = _.mapValues(groupedData, (group) => {
			return group.map(item => item.user_role_applications.map(role => role.application_code));
		});
		const exis_app = _.uniq(_.flatMap(result));
		const existing_app = (exis_app) ? exis_app.join(",") : '';
		if (existing_app.indexOf(accessControl.activeUser.account_info.application_code) !== -1) {
			// double_message = " This email has been used";
			alreadyExist = true;
		} else {
			// double_message = " Please be note that this email has been associated with system on application code " + existing_app + ", the email and password will remain the same for both system login";
		}
	}
	return alreadyExist
}
export async function createUser(postData) {
	const resp = await httpPost(configs.services.access_control + '/user', postData , true)
	return getResponse(resp);
}
export async function updateUser(id, postData) {
	const resp = await httpPut(configs.services.access_control + '/user/' + id, postData , true)
	return getResponse(resp);
}
export async function deleteUser(id) {
	const resp = await httpDelete(configs.services.access_control + '/user/' + id , {}, true)
	return getResponse(resp);
}
export async function getBankersList(data = {}) {
	const resp = await httpGet(configs.services.access_control + '/user_banker_list', data , true)
	return getResponse(resp);
}
// Corporate
export async function getCorporateList(data = {}) {
	const resp = await httpGet(configs.services.access_control + '/corporate', data , true)
	return getResponse(resp);
}
export async function storeCorporate(postData) {
	const resp = await httpPost(configs.services.access_control + '/corporate', postData , true)
	return getResponse(resp);
}
export async function updateCorporate(id, postData) {
	const resp = await httpPut(configs.services.access_control + '/corporate/' + id, postData , true)
	return getResponse(resp);
}
export async function deleteCorporate(id) {
	const resp = await httpDelete(configs.services.access_control + '/corporate/' + id , {}, true)
	return getResponse(resp);
}
// User Bank Banker
export async function storeBankBranches(postData) {
	const resp = await httpPost(configs.services.access_control + '/user_banker_bank/bulk_store', postData , true)
	return getResponse(resp);
}
export async function deleteBankBranches(id) {
	const resp = await httpDelete(configs.services.access_control + '/user_banker_bank/bulk_delete/' + id, {} , true)
	return getResponse(resp);
}
